import { storeLocal } from '../../helpers/stores'
import i from '../../translations/i'

export interface AccessRestrictionParams {
  plan?: number
  checkBlackMark?: boolean
}

export interface AccessRestriction {
  restricted: boolean
  title: string | null
}

/**
 * Единая точка принятия решения "можно ли использовать элемент".
 * plan — порог тарифа для конкретного контрола. checkBlackMark — включает ли этот
 * конкретный контрол проверку глобального флага black_mark (не у всех элементов она
 * нужна), само значение флага при этом читается из localStorage здесь же, вызывающему
 * коду его передавать не нужно. Причин может стать больше (права доступа, feature-флаги
 * и тд) — добавлять их нужно только здесь, withAccessRestriction и Restricted* не меняются.
 */
export const resolveAccessRestriction = ({ plan = 0, checkBlackMark = false }: AccessRestrictionParams): AccessRestriction => {
  if (checkBlackMark && storeLocal.get('black_mark')) {
    return { restricted: true, title: i.t('def:errors.blackMarkRestricted') }
  }

  if (plan > 0 && storeLocal.get('pricing_plan') < plan) {
    return { restricted: true, title: i.t('def:errors.pricing_plan') }
  }

  return { restricted: false, title: null }
}
